/**
 * "Save this program free" on www.gradmap.com sends visitors to
 * #/public/register?program=<id> (or #/public/login?program=<id>).
 * We remember the program and open it once the student is fully signed in
 * (after phone check and plan choice), so they land on the program they wanted.
 */
const KEY = 'gradmap_program_after_signin';
const MAX_AGE_MS = 2 * 24 * 60 * 60 * 1000;

export function rememberProgramFromSearch(search: string): void {
  try {
    const id = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search).get('program');
    if (id && /^\d{1,9}$/.test(id)) localStorage.setItem(KEY, JSON.stringify({ id, at: Date.now() }));
  } catch {
    // Storage blocked: the student just lands on the dashboard.
  }
}

/** The remembered program id, removed as it is read. */
export function takeProgramAfterSignin(): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    localStorage.removeItem(KEY);
    const v = JSON.parse(raw);
    return v && /^\d{1,9}$/.test(String(v.id)) && Date.now() - Number(v.at) < MAX_AGE_MS ? String(v.id) : null;
  } catch {
    return null;
  }
}

export function hasProgramAfterSignin(): boolean {
  try {
    return !!localStorage.getItem(KEY);
  } catch {
    return false;
  }
}
